module.exports = __webpack_public_path__ + "d448475a4af4ba63e3fcc6aa152dcb71.svg";